import React, { FC, useContext, useCallback } from 'react'
import { useSelector } from 'react-redux'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import ManageContext from '../contexts/manage'

import * as yup from 'yup'

import {
  FormSchema,
} from '@kaidam/fc-frontend/src/types/form'

import {
  IData_Manage_Login_Request,
} from '@kaidam/fc-shared/src/types/schema/booking'

import Form from '@kaidam/fc-frontend/src/components/form/Wrapper'

import routerSelectors from '@kaidam/fc-shared/src/frontend/store/selectors/router'

type FormType = IData_Manage_Login_Request

const formSchema: FormSchema = [{
  id: 'reference',
  title: 'Booking Reference',
  helperText: 'Your booking reference',
}, {
  id: 'emailpostcode',
  title: 'Email Address or Postcode',
  helperText: 'Enter the email address or postcode used to make the booking',
}]

const validationSchema = yup.object().shape({
  reference: yup.string().required(),
  emailpostcode: yup.string().required(),
})

const ManageLogin: FC<React.PropsWithChildren<unknown>> = () => {
  const manage = useContext(ManageContext)

  const onLogin = useCallback((payload: FormType) => {
    manage.login(payload)
  }, [])

  const params = useSelector(routerSelectors.params)

  const initialValues: FormType = {
    reference: params.reference as string || '',
    emailpostcode: params.emailpostcode as string || '',
  }

  return (
    <Box sx={{ display: 'flex', p: 2 }}>
      <Box sx={{ width: '100%', p: 3 }}>
        <Typography gutterBottom variant="h6">
          Login
        </Typography>
        <Form
          validationSchema={ validationSchema }         
          error={ manage.loginError }
          initialValues={ initialValues }
          onSubmit={ onLogin }
        >
          {
            ({
              render,
              isValid,
              onSubmit,
            }) => {
              return (
                <div>
                  { render(formSchema) }
                  <Box sx={{ mt: 4 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={ manage.loading || !isValid }
                      type="submit"
                      onClick={ onSubmit }
                    >
                      Login
                    </Button>
                  </Box>
                </div>
              )
            }
          }
        </Form>
      </Box>
    </Box>
  )
}

export default ManageLogin